var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.40772 18.3497C6.04691 17.7959 4.20357 15.9526 3.6498 13.5917C3.24987 11.8868 3.24987 10.1124 3.6498 8.40748C4.20357 6.04666 6.04691 4.20332 8.40772 3.64955C10.1127 3.24963 11.887 3.24963 13.592 3.64955C15.9528 4.20332 17.7961 6.04666 18.3499 8.40748C18.7498 10.1124 18.7498 11.8868 18.3499 13.5917C17.7961 15.9525 15.9528 17.7959 13.592 18.3497C11.887 18.7496 10.1127 18.7496 8.40772 18.3497Z",
    fill: "white",
    fillOpacity: 0.15,
    stroke: "white",
    strokeWidth: 1.275
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.9998,
    cy: 13.975,
    r: 0.85,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2998 9.2998V8.87481C9.2998 7.93592 10.0609 7.1748 10.9998 7.1748V7.1748V7.1748C11.9387 7.1748 12.6998 7.93592 12.6998 8.87481V8.97793C12.6998 9.45615 12.5098 9.91478 12.1717 10.2529L10.9998 11.4248",
    stroke: "white",
    strokeWidth: 1.275,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuSupport);
export default __webpack_public_path__ + "static/media/menuSupport.43f733ffd72de409db2f80745e9c155b.svg";
export { ForwardRef as ReactComponent };